import { render, staticRenderFns } from "./WPAlert.vue?vue&type=template&id=3b7d5544"
import script from "./WPAlert.vue?vue&type=script&lang=ts"
export * from "./WPAlert.vue?vue&type=script&lang=ts"
import style0 from "./WPAlert.vue?vue&type=style&index=0&id=3b7d5544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports